import './amplify-config';
import { createApp } from 'vue';
import App from './App.vue';
import router from './Router';

// Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

// Icons
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import '@mdi/font/css/materialdesignicons.css';

//Fonts
import '@fontsource/roboto';

// CSS
import '@/assets/css/theme.css';
import '@/assets/css/stylesheet.css';
import '@/assets/css/old-veutify.css';
import '@vueup/vue-quill/dist/vue-quill.snow.css';

// Amplify
import AmplifyVue from '@aws-amplify/ui-vue';
import '@aws-amplify/ui-vue/styles.css';

// Mapboxgl
import 'mapbox-gl/dist/mapbox-gl.css';

// Plugins
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import 'vue-toast-notification/dist/theme-sugar.css';
import {QuillEditor} from "@vueup/vue-quill";

// Suppress benign ResizeObserver loop errors in Vite's dev overlay
const ignoredErrors = [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications.',
]
window.addEventListener('error', (e) => {
    if (ignoredErrors.includes(e.message)) {
        e.stopImmediatePropagation()
    }
})

const vuetify = createVuetify({
    components,
    directives,
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi
        }
    }
});

const app = createApp(App)
    .use(router)
    .use(vuetify)
    .use(AmplifyVue)
    .use(ToastPlugin)
    .mount('#app');